import { ColorTheme } from 'types/theme';
import { TTextColor } from 'components/Text/Text.types';

export const TITLE_COLORS: { [key in ColorTheme]: TTextColor } = {
  light: 'primary',
  dark: 'white',
};
export const ACTION_COLORS: { [key in ColorTheme]: string } = {
  light: '#333',
  dark: '#fff',
};
